import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-home-video-demo',
  templateUrl: './home-video-demo.component.html',
  styleUrls: ['./home-video-demo.component.scss']
})
export class HomeVideoDemoComponent {
  @Input() isPlaying: boolean = false;
  @Input() videoPath: string = 'videos/teaser.mp4';

  @ViewChild('videoElement') videoElement: ElementRef<HTMLVideoElement> | undefined;

  @Output() playMainVideoEvent = new EventEmitter<void>();
  @Output() closeVideoEvent = new EventEmitter<void>();

  playMainVideo(): void {
    this.playMainVideoEvent.emit();
  }

  closeVideo(): void {
    this.closeVideoEvent.emit();
  }
}